import {
  GetUserChatsRequest,
  GetUserChatsResponse,
  GetUsersRequest,
  GetUsersResponse,
  GetUserTransmissionDemandsRequest,
  GetUserTransmissionDemandsResponse,
} from "../types/operator";
import { ApiResponse, operatorApiClient } from "./api";

export class OperatorAuthService {
  logout(): void {
    // 운영자 토큰 및 관련 데이터 제거
    localStorage.removeItem("operatorAccessToken");
    localStorage.removeItem("operatorUserInfo");
    // 운영자 로그인 페이지로 리다이렉트
    window.location.href = "/operator/auth";
  }

  // 운영자 인증 상태 확인
  isAuthenticated(): boolean {
    return Boolean(localStorage.getItem("operatorAccessToken"));
  }

  // 토큰 가져오기
  getToken(): string | null {
    return localStorage.getItem("operatorAccessToken");
  }
}

export class OperatorService {
  /**
   * 회원 목록 조회
   */
  async getUsers(
    params: GetUsersRequest = {}
  ): Promise<ApiResponse<GetUsersResponse>> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.search) queryParams.append("search", params.search);

    const queryString = queryParams.toString();
    const endpoint = queryString
      ? `/operator/users?${queryString}`
      : "/operator/users";

    return operatorApiClient.get<GetUsersResponse>(endpoint);
  }

  /**
   * 유저 채팅 이력 조회
   */
  async getUserChats(
    userId: string,
    params: GetUserChatsRequest = {}
  ): Promise<ApiResponse<GetUserChatsResponse>> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());

    const queryString = queryParams.toString();
    const endpoint = queryString
      ? `/operator/users/${userId}/chats?${queryString}`
      : `/operator/users/${userId}/chats`;

    return operatorApiClient.get<GetUserChatsResponse>(endpoint);
  }

  /**
   * 유저 전송요구서 내역 조회
   */
  async getUserTransmissionDemands(
    userId: string,
    params: GetUserTransmissionDemandsRequest = {}
  ): Promise<ApiResponse<GetUserTransmissionDemandsResponse>> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());

    const queryString = queryParams.toString();
    const endpoint = queryString
      ? `/operator/users/${userId}/transmission-demands?${queryString}`
      : `/operator/users/${userId}/transmission-demands`;

    return operatorApiClient.get<GetUserTransmissionDemandsResponse>(endpoint);
  }
}

export const operatorAuthService = new OperatorAuthService();
export const operatorService = new OperatorService();
